import React from "react";
import SvgBox from "./box/SvgBox";
import { BoxProps, Box } from "./box";

const baseProps = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  rounded: "md",
  transition: "all 0.2s",
  flex: "0 0 auto",
  _hover: { bg: "blackAlpha.100" },
  _active: { bg: "blackAlpha.200" },
  _disabled: {
    cursor: "not-allowed",
  },
  _focus: {
    boxShadow: "outline",
  },
};

const sizes = {
  xl: {
    button: "40px",
    icon: "20px",
  },
  lg: {
    button: "40px",
    icon: "16px",
  },
  md: {
    button: "32px",
    icon: "12px",
  },
  sm: {
    button: "24px",
    icon: "10px",
  },
};

export interface ICloseButton {
  /**
   * The size of the close button
   */
  size?: "xl" | "lg" | "md" | "sm";
  /**
   * If `true`, the close button will be disabled
   */
  disabled?: boolean;
  /**
   * The color of the close icon
   */
  color?: string;
  /**
   * An accessible label for the close button
   */
  "aria-label"?: string;
  /**
   * The type of button (defaults to button)
   */
  type?: string;
}

type CloseButtonProps = ICloseButton & Omit<BoxProps, "size">;

const CloseButton: React.FC<CloseButtonProps> = ({
  size = "md",
  type = "button",
  disabled = false,
  color,
  "aria-label": ariaLabel = "Close",
  ...rest
}: CloseButtonProps) => {
  const buttonSize = sizes[size] && sizes[size].button;
  const iconSize = sizes[size] && sizes[size].icon;

  return (
    <Box
      as="button"
      outline="none"
      aria-disabled={disabled}
      // @ts-ignore
      disabled={disabled}
      aria-label={ariaLabel}
      size={buttonSize}
      type={type}
      {...baseProps}
      {...rest}
    >
      <SvgBox size={iconSize} color={color} viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        />
      </SvgBox>
    </Box>
  );
};

export default CloseButton;
